<template>
    <div>
      <b-tabs>
        <b-tab title="Routers">
          <b-card>
            <b-table
                sticky-header
                id="RouterTable"
                :items="RouterList"
                :headers="fields"
                no-border-collapse
                hover
                show-empty
                empty-text="You currently dont have any Routers at this location"
                responsive
                small
                >
                    <template v-slot:cell(Edit)=" {item}">
                    <b-button variant="outline-info" v-on:click="EditRouter(item)">Edit</b-button>
                    </template>
            </b-table>
        </b-card>
        <br />
        </b-tab>
      </b-tabs>
      <b-modal
      ref="LoadingModal"
      id="LoadingModal"
      content-class="Modal"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      centered
      hide-header
    >
    <div class="container_row" >
        <div class="layer2">
          <h1 class="HeadingText1">Loading Data...</h1>

          <img
            class="Logo"
            alt="Angelguard logo"
            src="../assets/LogoOnly.png"
          />
        </div>
    </div>
</b-modal>
<b-modal
      ref="EditRouterModal"
      id="EditRouterModal"
      title="Router Edit"
      content-class="Modal"
      hide-footer
      centered
      class="Modal"
    >
    <b-card>
      <b-row><b-col>Router Name:</b-col><b-col>{{ RouterforEdit.RouterName }}</b-col></b-row>
      <b-row><b-col>Router Type:</b-col><b-col>{{ RouterforEdit.RouterType }}</b-col></b-row>
      <b-row><b-col>Router Location:</b-col>
        <b-col><b-form-input v-model="EditedRouter.Location"
          :placeholder="RouterforEdit.Location"></b-form-input></b-col></b-row>
      <b-row><b-col>Dept/Floor: </b-col>
        <b-col><b-form-input v-model="EditedRouter.DeptFloor"
          :placeholder="RouterforEdit.DeptFloor"></b-form-input></b-col></b-row>
    </b-card>
    <b-row>
      <b-col><b-button variant="outline-success" size="small" v-on:click="SubmitEdit()">Submit</b-button></b-col>
      <b-col><b-button variant="outline-danger" size="small" v-on:click="CancelEdit()">Cancel</b-button></b-col>
    </b-row>
</b-modal>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  
  export default {
    data() {
      return {
        selectedlocation: localStorage.getItem("location"),
        UserAccess: localStorage.getItem("accessGroup"),
        UserURN: localStorage.getItem("UserURN"),
        UserProfile: localStorage.getItem("profileportal"),
        fullname: localStorage.getItem("fullname"),
        loaded: true,
        RouterArray: [],
        RouterList: [],
        fields: [
        { key: "RouterName", label:"Name" },
        { key: "RouterType", label:"Type"},
        { key: "Location" },
        { key: "DeptFloor", label: "Dept/Floor"},
        { key: "Edit"}
      ],
      RouterforEdit: {
        "RouterName": "",
        "RouterType":"",
        "Location": "",
        "DeptFloor": ""
      },
      EditedRouter: {
        "RouterName": "",
        "RouterType":"",
        "Location": "",
        "DeptFloor": ""
      }
      };
    },
    mounted() {
       this.loaded = false
       this.RouterList = []
      let LookUpLogsUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpLogsHeaders = this.$apikeyPost;
    let LookUpLogsRequest = {
      RequestType: "Router",
      Location: this.selectedlocation,
    };
    axios
      .post(LookUpLogsUrl, LookUpLogsRequest, LookUpLogsHeaders)
      .then((response) => {
        this.RouterArray = response.data.Values
        for(let x=0;x<this.RouterArray.length;x++){
          this.RouterList.push({
            "RouterName": this.RouterArray[x][0],
            "RouterType": this.RouterArray[x][1],
            "Location": this.RouterArray[x][5],
            "DeptFloor": this.RouterArray[x][6],
            "Edit":""

          })
        }
      });
       this.loaded = true
      
    },
  
    components: {},
    methods: {
      Showloader() {
      if (this.loaded) {
        this.$bvModal.hide("LoadingModal");
      } else if (this.loaded == false) {
        this.$bvModal.show("LoadingModal");
      }
    },
    EditRouter(item){
      this.RouterforEdit = item
      this.EditedRouter = this.RouterforEdit
        this.$refs['EditRouterModal'].show(this.RouterforEdit)
    },
    SubmitEdit(){
      let SubmitUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let SubmitHeaders = this.$apikeyPost;
         let SubmitRequest = {
          RequestType: "GatewayUpdate",
          DeviceDict: [
            {
              "RouterName": this.EditedRouter.RouterName,
              "LocationNote": this.EditedRouter.Location,
              "DeptFloor": this.EditedRouter.DeptFloor
            },
          ],
        };
        axios
          .post(SubmitUrl, SubmitRequest, SubmitHeaders)
          .then((response) => {
            response;
            alert("Router information Updated");
            this.$refs['EditRouterModal'].hide()
            this.RefreshList();

          });

    },
    CancelEdit(){
      this.RouterforEdit = {
        "RouterName": "",
        "RouterType": "",
        "Location": "",
        "DeptFloor": ""
      }
      this.EditedRouter= {
        "RouterName": "",
        "RouterType": "",
        "Location": "",
        "DeptFloor": ""
      }
      this.$refs['EditRouterModal'].hide()
      this.RefreshList()
    },
    RefreshList(){
      this.loaded = false
      this.RouterList = []
      let LookUpLogsUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpLogsHeaders = this.$apikeyPost;
    let LookUpLogsRequest = {
      RequestType: "Router",
      Location: this.selectedlocation,
    };
    axios
      .post(LookUpLogsUrl, LookUpLogsRequest, LookUpLogsHeaders)
      .then((response) => {
        this.RouterArray = response.data.Values
        for(let x=0;x<this.RouterArray.length;x++){
          this.RouterList.push({
            "RouterName": this.RouterArray[x][0],
            "RouterType": this.RouterArray[x][1],
            "Location": this.RouterArray[x][5],
            "DeptFloor": this.RouterArray[x][6],
            "Edit":""

          })
        }
      });
      this.loaded = true
    },
    },
    watch: {
      loaded() {
      this.Showloader();
    },
    },
 
  };
  </script>
  <style scoped>
.content {
    text-align: center;
  }
  .blueCircle {
  animation-name: BackgroundGlow;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  border-radius: 15rem;
  height: 8rem;
  width: 8rem;
  background-color: rgb(109, 136, 195);
  opacity: 0.3;
  margin-top: 10rem;
  margin-left: auto;
  margin-right: auto;
  animation-timing-function: linear;
}
.layer1,
.layer2 {
  grid-column: 1;
  grid-row: 1;
  background-color: rgb(109, 136, 195);
  opacity: 0.5;
}
.layer1 span {
  display: grid;
  place-items: center;
}

.Logo {
  scale: 150%;
  margin-top: 5rem;
  width: 15%;
  min-width: 150px;
}</style>
  